import React from 'react'

import { SectionDynamicKey, TypeSectionDynamic } from '../../../lib/types'
import { PageSection } from '../../page-section'
import { ContentProps } from '../../renderer'
import { AIDetector } from '../../dynamic/ai-detector'
import { BTS2025ScrollingBanner } from '../../dynamic/bts-2025-scrolling-banner'
import { useExperimentService } from '../../../lib/hooks'
import { CompactSectionsContext } from '@contexts/compact-sections-context'

const DynamicSectionContent: React.FC<ContentProps<TypeSectionDynamic>> = (props) => {
  const { key } = props.structure.fields

  switch (key) {
    case SectionDynamicKey.AIDetector:
      return <AIDetector />

    case SectionDynamicKey.BTS2025scrollingBanner:
      return <BTS2025ScrollingBanner />
    default:
      return null
  }
}

export const DynamicSection: React.FC<ContentProps<TypeSectionDynamic>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, background, heading },
  } = structure

  const { isTools2_XWithLoggedInEnabled } = useExperimentService()

  const isAIDetector = structure.fields.key === SectionDynamicKey.AIDetector
  const isToolsRedesignAndAIDetector = isTools2_XWithLoggedInEnabled() && isAIDetector

  return (
    <CompactSectionsContext.Provider value={isToolsRedesignAndAIDetector}>
      <PageSection
        internalName={internalName}
        sysStructure={sys}
        className={className}
        heading={heading}
        background={background}
        isToolsRedesign2_XEnabled={isToolsRedesignAndAIDetector}
      >
        <DynamicSectionContent structure={structure} />
      </PageSection>
    </CompactSectionsContext.Provider>
  )
}
